import {
  IMeasurePropertiesFieldsFragment,
  IMeasureFieldsFragment,
} from '../../apollo/graphqlSchema';
import { IRow } from '../../../redux/slices/oldBuilder';
import { parseCompoundMeasure, parseSimpleMeasure } from './utils';
import { assertCondition, assertNotNil } from '../../types';

/**
 * A function will parse data table Simple or Compound measure and
 * measureProperties to builder
 */
export const parseDataTableMeasureToBuilder = (
  measures: IMeasureFieldsFragment[],
  measuresProperties: IMeasurePropertiesFieldsFragment[],
): IRow[] => {
  return measures.map((measure, index) => {
    const measureProperties = measuresProperties[index];

    assertNotNil(measureProperties);

    if (
      measure.__typename === 'SimpleMeasure' &&
      measureProperties.__typename === 'SimpleMeasureProperties'
    ) {
      return parseSimpleMeasure(measure, measureProperties);
    } else {
      assertCondition(
        measure.__typename === 'CompoundMeasure' &&
          measureProperties.__typename === 'CompoundMeasureProperties',
      );

      return parseCompoundMeasure(measure, measureProperties);
    }
  });
};
